export default __webpack_public_path__ + "static/media/slot23.39f10402.png";